import { render, staticRenderFns } from "./DisplayWeb.vue?vue&type=template&id=29276fda&"
import script from "./DisplayWeb.vue?vue&type=script&lang=js&"
export * from "./DisplayWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports